import { render, staticRenderFns } from "./DetailThumbnailLoader.vue?vue&type=template&id=cdf38306&scoped=true&"
import script from "./DetailThumbnailLoader.vue?vue&type=script&lang=js&"
export * from "./DetailThumbnailLoader.vue?vue&type=script&lang=js&"
import style0 from "./DetailThumbnailLoader.vue?vue&type=style&index=0&id=cdf38306&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdf38306",
  null
  
)

export default component.exports